/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { MenuClusterActionsService } from '@app/cluster-management/menu-cluster-actions/menu-cluster-actions.service';
import { routeContextActionCluster } from '@app/cluster-management/ngrx/cluster-management.selectors';
import { clustersLoaded } from '@app/core/ngrx';
import { getAllRouteParams } from '@common/utils/router';
import { Store } from '@ngrx/store';
import { ClusterId } from '@shared/types/cluster';
import { filter, map, switchMap } from 'rxjs';

export const clusterCanUpdateLicenseGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const { contextActionClusterId } = getAllRouteParams<{ contextActionClusterId: ClusterId }>(route);
  const redirectTo = createUrlTreeFromSnapshot(route, ['..']);
  const store = inject(Store);
  const service = inject(MenuClusterActionsService);
  return !contextActionClusterId
    ? redirectTo
    : store.select(clustersLoaded).pipe(
        filter((loaded) => loaded),
        switchMap(() =>
          store
            .select(routeContextActionCluster)
            .pipe(
              map((clusterInfo) =>
                !!clusterInfo &&
                service.isUpdateLicenseButtonVisible(clusterInfo) &&
                !service.isUpdateLicenseButtonDisabled(clusterInfo)
                  ? true
                  : redirectTo,
              ),
            ),
        ),
      );
};
